import cmpConfig from '../cmpConfig/defaultCmpConfig';
import IntegrationConnector from '../../../utils/fc-components/IntegrationConnector';

import { registerComponent } from '../../../utils/fc-components/registerComponent';

registerComponent(IntegrationConnector, cmpConfig);
